export class FileModel {
  filename: string;
  file: string;
  description: string;
  size: number;
}
